import { c as a } from "../../_utils/cssr/index.js";
import r from "../common/_common.js";
const {
  cubicBezierEaseIn: i,
  cubicBezierEaseOut: s
} = r;
function p({
  transformOrigin: c = "inherit",
  duration: e = ".2s",
  enterScale: o = ".9",
  originalTransform: n = "",
  originalTransition: t = ""
} = {}) {
  return [a("&.fade-in-scale-up-transition-leave-active", {
    transformOrigin: c,
    transition: `opacity ${e} ${i}, transform ${e} ${i} ${t && `,${t}`}`
  }), a("&.fade-in-scale-up-transition-enter-active", {
    transformOrigin: c,
    transition: `opacity ${e} ${s}, transform ${e} ${s} ${t && `,${t}`}`
  }), a("&.fade-in-scale-up-transition-enter-from, &.fade-in-scale-up-transition-leave-to", {
    opacity: 0,
    transform: `${n} scale(${o})`
  }), a("&.fade-in-scale-up-transition-leave-from, &.fade-in-scale-up-transition-enter-to", {
    opacity: 1,
    transform: `${n} scale(1)`
  })];
}
export {
  p as fadeInScaleUpTransition
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_styles/transitions/fade-in-scale-up.cssr.js
// module id = 126
// module chunks = 67